import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=a1a8031e&"
import script from "./Score.vue?vue&type=script&lang=js&"
export * from "./Score.vue?vue&type=script&lang=js&"
import style0 from "./Score.vue?vue&type=style&index=0&id=a1a8031e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports